import { useForm } from '@mantine/form';

export type Fields = {
  aiId: number | string;
  template: string;
};

type Params = {
  initialValues: Fields;
};

export const useAIPromptTemplateForm = ({ initialValues }: Params) => {
  return useForm<Fields>({
    initialValues,
    validate: {
      aiId: (value) => {
        if (!value && value !== 0) {
          return 'AI ID is required';
        }
        if (Number.isNaN(Number(value))) {
          return 'AI ID must be a number';
        }
        return null;
      },
      template: (value) => {
        if (!value) {
          return 'Template is required';
        }
        if (!value.includes('###user_msg###') || !value.includes('###relevant_context###')) {
          return 'Template must include ###user_msg### and ###relevant_context### placeholders';
        }
        return null;
      },
    },
  });
};
